import { HydrationFile, HydrationResult } from '../hydration.models';
import type { CooUploadedFile } from '../ku4-draft.models';

export type DocumentFileBuckets = Pick<
  HydrationResult,
  'documentFiles' | 'letterFiles' | 'taxFiles'
>;

function toHydrationFile(file: CooUploadedFile): HydrationFile | undefined {
  const result: HydrationFile = {};

  if (file.fileName !== undefined) {
    result.filename = file.fileName;
  }

  if (file.fileType !== undefined) {
    result.fileExtension = file.fileType;
  }

  return Object.keys(result).length ? result : undefined;
}

/**
 * Splits the draft's single flat uploadedFiles array back into the three upload slices.
 * A missing or unrecognised category falls back to DOCUMENT so drafts written before
 * category was populated hydrate exactly as they did before.
 *
 * Shared by the inheritance and minor hydrators so the category split cannot drift
 * between the two flows.
 */
export function buildDocumentFileBuckets(
  uploadedFiles: CooUploadedFile[] | undefined,
): DocumentFileBuckets {
  const buckets: DocumentFileBuckets = {};

  for (const file of uploadedFiles ?? []) {
    const hydrationFile = toHydrationFile(file);

    if (!hydrationFile) {
      continue;
    }

    let key: keyof DocumentFileBuckets = 'documentFiles';

    if (file.category === 'LETTER') {
      key = 'letterFiles';
    } else if (file.category === 'TAX') {
      key = 'taxFiles';
    }

    buckets[key] = [...(buckets[key] ?? []), hydrationFile];
  }

  return buckets;
}
